import axios from 'axios';

export function downloadAllResults(week, filePath, fileResultsOverview, fileKmsPerWeek) {
    const formData = new FormData();
    formData.append('week', week);
    formData.append('jsonFile', filePath);
    formData.append('fileResultsOverview', fileResultsOverview);
    formData.append('fileKmsPerWeek', fileKmsPerWeek);

    return axios({
        method: 'post',
        responseType: 'arraybuffer',
        url: '/api/comparison/all-results',
        data: formData,
    });
}

export function downloadSummaryKmsPerWeek(file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios({
        method: 'post',
        responseType: 'arraybuffer',
        url: '/api/comparison/summary-kms-week',
        data: formData,
    });
}

export function getJsonFilesList() {
    return axios.get('/api/comparison/get-json-files-list');
}

export function retrieveMendriXData(week) {
    const formData = new FormData();
    formData.append('week', week);

    return axios({
        method: 'post',
        responseType: 'json',
        url: '/api/comparison/mendrix-start',
        data: formData,
    });
}

export function loadMendriXStatus(week) {
    const formData = new FormData();
    formData.append('week', week);

    return axios({
        method: 'post',
        responseType: 'json',
        url: '/api/comparison/mendrix-status',
        data: formData,
    });
}

export function terminateMendriXRetrieval(week) {
    const formData = new FormData();
    formData.append('week', week);

    return axios({
        method: 'post',
        responseType: 'json',
        url: '/api/comparison/mendrix-terminate',
        data: formData,
    });
}
